import { openBlock as c, createElementBlock as e, createElementVNode as t } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, l = /* @__PURE__ */ t("path", { d: "M17.836 3.474a8.776 8.776 0 0 0-6.85-2.16c-3.94.44-7.16 3.62-7.66 7.54-.42 3.31 1.02 6.52 3.76 8.38.73.5 1.16 1.33 1.16 2.24v2.52c0 .41.34.75.75.75h6c.41 0 .75-.34.75-.75v-2.52c0-.9.46-1.75 1.22-2.28a8.756 8.756 0 0 0 3.78-7.2c0-2.49-1.07-4.87-2.92-6.53l.01.01Zm-3.58 17.78h-4.5v-1.19h4.5v1.19Zm1.87-5.29c-.91.63-1.53 1.56-1.76 2.6h-1.71v-3.83l1.98-1.98c.29-.29.29-.77 0-1.06a.754.754 0 0 0-1.06 0l-1.67 1.67-1.66-1.66a.755.755 0 0 0-1.06 0c-.29.29-.29.77 0 1.06l1.97 1.97v3.83h-1.51a4.146 4.146 0 0 0-1.72-2.56 7.254 7.254 0 0 1-3.12-6.95c.42-3.26 3.09-5.88 6.35-6.25 2.1-.23 4.12.4 5.68 1.79a7.27 7.27 0 0 1 2.42 5.41c0 2.38-1.17 4.61-3.13 5.96Z" }, null, -1), n = [
  l
];
function a(h, r) {
  return c(), e("svg", o, [...n]);
}
const v = { render: a };
export {
  v as default,
  a as render
};
